export const DDStatusTypes = ['canRuleOut', 'pathEnd', 'ruledOut', 'admitted']; //must be in order of lifecycle
export const ConsiderationGroupEnum = {
    HIGH_CONSIDERATION: 'high_consideration',
    LOW_CONSIDERATION: 'low_consideration',
    BELOW_THRESHOLD: 'below_threshold',
};
export const DispositionRecommendedAction = {
    ADMIT: 'admit',
    DISCHARGE: 'discharge',
    ENGAGED_ENCOUNTER: 'engaged_encounter'
};
export const RequiredSnippetStatus = {
    INCOMPLETE: 'incomplete',
    FULFILLED: 'fulfilled'
};
export const DispositionStatus = {
    NOT_REACHED: 'not_reached',
    INITIATED: 'initiated',
    DONE: 'done'
};
export const PathwayStatus = {
    STATES_NAVIGATING: 'states_navigating',
    INITIALIZED: 'initialized',
    REACHED_ADMIT: 'reached_admit',
    REACHED_DISCHARGE: 'reached_discharge',
    REACHED_REASSESSMENT: 'reached_reassessment',
    REACHED_CC_PROTOCOL_END: 'reached_cc_protocol_end',
    REACHED_OS_PROTOCOL_END: 'reached_os_protocol_end',
    ADMIT_COMPLETED: 'admit_completed',
    DISCHARGE_COMPLETED: 'discharge_completed'
};
// Backend-owned placement: the EM ProtocolPlacementModule is the single source
// of truth for which UI list a runtime protocol falls into. The frontend buckets
// purely by this value and never re-derives placement from status/orders.
export const ProtocolListAssignment = {
    CONSIDER_NOW: 'consider_now',
    CONSIDER_LATER: 'consider_later',
    ENDED: 'ended',
    EXECUTED: 'executed',
};
export const CareMapCriticality = ['Critical', 'Urgent', 'Non-Urgent'];
//caremap types
export const DiseaseProfileViewEnum = {
    COMPLICATIONS: 'complications',
    EXAM: 'exam $1',
    ADMINISTRATIVE: 'administrative $1',
    LABORATORY: 'laboratory $1',
    RISK_FACTORS: 'risk_factors',
    IMAGING: 'imaging $0',
    COMPLAINTS: 'complaints $1',
    EKG: 'ekg $1',
    PRECIPITATING_FACTORS: 'precipitating_factors',
    RELIEVING_FACTORS: 'relieving_factors',
    VITAL_SIGNS: 'vital_signs $0',
    DIFFERENTIAL_DIAGNOSIS: 'differential_diagnosis',
    TREATMENTS: 'treatments',
    NoneView: 'NoneView',
};
export var CareMap_RuleStatus;
(function (CareMap_RuleStatus) {
    CareMap_RuleStatus[CareMap_RuleStatus["RULE_IN"] = 1] = "RULE_IN";
    CareMap_RuleStatus[CareMap_RuleStatus["NORMAL"] = 0] = "NORMAL";
    CareMap_RuleStatus[CareMap_RuleStatus["RULE_OUT"] = -1] = "RULE_OUT";
})(CareMap_RuleStatus || (CareMap_RuleStatus = {}));
// LLM validator disposition mirrored from caremap.LLMValidationStatus (Python).
export const CareMapLLMStatus = {
    VALIDATED: 'validated',
    REJECTED: 'rejected',
    NOT_EVALUATED: 'not_evaluated',
};
// The system's final verdict for a disease — mirrored from caremap.PlacementReason
// (Python). Explains where a disease landed (consider now / later) or why it did
// not surface as a protocol. Stamped for debug clarity; consumed by the dev view.
export const CareMapPlacementReason = {
    // High Consideration (List A)
    MANUAL_PROMOTE: 'manual_promote',
    RULE_IN: 'rule_in',
    FOUNDATIONAL: 'foundational',
    WITHIN_CAP: 'within_cap',
    // Low Consideration (List B)
    SPILL_OVER: 'spill_over',
    MANUAL_DEMOTE: 'manual_demote',
    // Not surfaced (no protocol)
    RULED_OUT: 'ruled_out',
    BELOW_LLM_BAR: 'below_llm_bar',
    LLM_REJECTED: 'llm_rejected',
    BELOW_SELECTOR_BAR: 'below_selector_bar',
    OVER_ACTIVE_CAP: 'over_active_cap',
};
//# sourceMappingURL=types.js.map